import { ADS_MODE, ADSENSE_CLIENT_ID } from "@/config/ads";

const KEY = "fydate_cookie_consent";
const EVT = "fydate-consent";

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    if (raw === "1") return { necessary: true, ads: false };
    return JSON.parse(raw);
  } catch { return null; }
}

export function setConsent(c) {
  try { localStorage.setItem(KEY, JSON.stringify({ necessary: true, ads: !!c.ads, at: new Date().toISOString() })); } catch {}
  if (window.gtag) {
    const v = c.ads ? "granted" : "denied";
    window.gtag("consent", "update", { ad_storage: v, ad_user_data: v, ad_personalization: v });
  }
  window.dispatchEvent(new Event(EVT));
}

export function onConsentChange(cb) {
  window.addEventListener(EVT, cb);
  return () => window.removeEventListener(EVT, cb);
}

export function adsAllowed() {
  return ADS_MODE === "adsense" && !!ADSENSE_CLIENT_ID && !!getConsent()?.ads;
}

export function loadAdsense() {
  if (!adsAllowed() || document.getElementById("adsense-script")) return;
  const s = document.createElement("script");
  s.id = "adsense-script";
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`;
  document.head.appendChild(s);
}
